import {Component, EventEmitter, OnDestroy, OnInit, Output} from '@angular/core';
import {DataConfig} from '../../../shared/models/tabs-data';
import {Observable, Subscription} from 'rxjs';
import {SiteGetInfoService} from '../../services/site-get-info.service';
import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Address} from '../../../shared/models/address';
import {Router} from '@angular/router';

@Component({
  selector: 'storever-addresses-edit',
  templateUrl: './addresses-edit.component.html',
  styleUrls: ['./addresses-edit.component.scss']
})
export class AddressesEditComponent implements OnInit, OnDestroy {

  dataConfig: DataConfig;
  content: Observable<Address[]>;
  @Output() saveForm = new EventEmitter<Object>();
  private sub$: Subscription;
  private subscriptions = [];

  constructor(private siteGetInfoService: SiteGetInfoService, private fb: FormBuilder , private router: Router) {
  }

  ngOnInit(): void {
    this.dataConfig.form.disable();
    this.content = this.dataConfig.content;
    this.content.subscribe((addresses: Address[]) => {
      for (let i = 0; i < addresses.length; i++) {
        if (!this.form.at(i)) {
          this.add();
          this.form.at(i).disable();
        }
        this.form.at(i).patchValue(addresses[i]);
        this.patchCountry(i, addresses[i]);
      }
    })
  }

  ngOnDestroy(): void {
    this.dataConfig.form.markAsPristine();

    if (this.subscriptions.length) {
      this.subscriptions.forEach(sub => sub.unsubscribe());
    }
  }

  /**
   * - getRawValue from FormGroup even if disabled
   * - Update/patch part of the order
   * @param apiName
   */
  save(apiNames: string[]): void {
    const poz = +apiNames[2];
    const resp = this.getFormAt(poz).value;
    if (this.router.url.split('?')[0].search('multi') !== -1) {
      this.saveForm.emit({ type: 'multiSubscription' , api: apiNames, data: resp });
    }
    else {
      this.saveForm.emit({ api: apiNames, data: resp });
    }

  }

  undo(formPath: string[]): void {
    this.dataConfigContentPatchForm(formPath);
  }

  dataConfigContentPatchForm(formPath?: string[]): void {
    this.content = this.dataConfig.content;
    this.sub$ = this.content.subscribe(sub => {
      if (formPath) {
        this.getFormAt(+formPath[1]).patchValue(sub[+formPath[1]]);
      } else {
        this.form.patchValue(sub);
      }
      this.patchCountry(0, sub[0]);
      // TODO: remove this by an dynamic content
      if (sub[1]) {
        this.patchCountry(1, sub[1]);
      }
    });
    this.subscriptions.push(this.sub$);
  }

  isOrderOpened(): Observable<boolean> {
    return this.siteGetInfoService.isOrderOpened()
  }

  get form(): FormArray {
    return this.dataConfig.form.get('addresses') as FormArray
  }

  getFormAt(poz: number): FormGroup {
    return this.form.at(poz) as FormGroup;
  }

  patchCountry(poz: number, data: Address): void {
    this.form.at(poz).get(['countryForm', 'name']).patchValue(data.country)
  }

  add(): void {
    this.form.push(this.fb.group({
      addressType: [null, Validators.required],
      checkBox: [true],
      city: [null, Validators.required],
      countryForm: this.fb.group({
        name: [null, Validators.required]
      }),
      country: [null],
      created: [null],
      createdBy: [null],
      id: [null],
      line1: [null, Validators.required],
      line2: [null],
      line3: [null],
      name: [null],
      state: [null],
      updated: [null],
      updatedBy: [null],
      uuid: [null],
      zip: [null, Validators.required]
    }));
  }

  getAddressType(poz: number): string {
    return this.getFormAt(poz).get('addressType').value.charAt(0).toUpperCase()
  }

  get isStatusOff$(): Observable<boolean> {
    return this.siteGetInfoService.isStatusOff()
  }

}

